import { Component, OnInit } from "@angular/core";
import { faTrash } from "@fortawesome/free-solid-svg-icons";
import { FormControl, Validators } from "@angular/forms";
import { FuncionariosService } from "../servicios/funcionarios.service";
import { Globals } from "../../globals";

@Component({
  selector: "app-encuesta",
  templateUrl: "./encuesta.component.html",
  styleUrls: ["./encuesta.component.css"]
})
export class EncuestaComponent implements OnInit {
  titulo: string = "Correos pendientes por envío de encuesta";
  lista: string[] = [""];
  faTrash = faTrash;

  controlEmail = new FormControl("", [Validators.required, Validators.email]);

  constructor(public funcionarioService: FuncionariosService, public globals: Globals) {}

  ngOnInit() {
    this.funcionarioService.noNotificados().subscribe(datos => {
      if (datos["status"] && datos["status"] === 200) {
        this.lista = datos.lista;
        
      }
    });
  }

  enviarEncuesta() {
    this.funcionarioService.enviarNotificacion({ lista: this.lista }).subscribe(datos => {
      
      console.log(datos);
      if ((datos.status = 200)) {
        //////conole.log("ingresado ok");
        this.globals.contenedorVarGlobal = "buscar";
      }
    });
  }

  borrarItem(indice: number) {
    this.lista.splice(indice, 1);
    
  }

  agregarCorreo() {
    this.lista.push("");
    console.log(this.lista)
  }

  trackByFn(index: any, item: any) {
    return index;
  }

  eliminarLista(){
    this.lista=[]
  }
}
